import { PATHNAMES } from '@/utils/pathnames';
import { getBaseAdminURL } from '@/utils/urls';
import isCurrentlyOnWebinarPlusDomain from './is-currently-on-webinarplus-domain';
import isCurrentlyOnBrandTVDomain from './is-currently-on-btv-domain';

export const getLeavePlatformLink = (path: string = '/live') => {
  const usePJDHomepage = import.meta.env.VITE_FORCE_ADMIN === 'true';
  const BRAND_TV_DOMAIN = import.meta.env.VITE_BRAND_TV_DOMAIN;
  const WEBINAR_PLUS_DOMAIN = import.meta.env.VITE_WEBINAR_PLUS_DOMAIN;

  if (isCurrentlyOnBrandTVDomain()) {
    return `https://app.${BRAND_TV_DOMAIN}${path}`;
  } else if (isCurrentlyOnWebinarPlusDomain()) {
    return `https://app.${WEBINAR_PLUS_DOMAIN}${path}`;
  }

  if (usePJDHomepage) {
    return PATHNAMES.Admin.Projects;
  }

  return getBaseAdminURL();
};
